/**
 * A predefined TaskOutput property.
 */
export class TaskOutputProperty {
    name: string;
    fieldName: string;
}
